import { render, staticRenderFns } from "./treeBox.vue?vue&type=template&id=53d6a65a&scoped=true"
import script from "./treeBox.vue?vue&type=script&lang=js"
export * from "./treeBox.vue?vue&type=script&lang=js"
import style0 from "./treeBox.vue?vue&type=style&index=0&id=53d6a65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d6a65a",
  null
  
)

export default component.exports